import { FC } from 'react';
import { useDelayedInvoiceChecker } from './useDelayedInvoiceChecker';
import { usePushNotificationChecker } from './usePushNotificationChecker';
import { useCommunicationChannelVerificationChecker } from './useCommunicationChannelVerificationChecker';

export const AuthenticatedUserChecks: FC<unknown> = () => {
  useDelayedInvoiceChecker();
  usePushNotificationChecker();
  useCommunicationChannelVerificationChecker();

  return null;
};
